import { render } from "./Main.vue?vue&type=template&id=b72f0d2e"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"
script.render = render

export default script